import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { publicPath } from '@remote/api/config'
import Close from './views/close/index.vue'
import Signout from './components/signout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('./views/index.vue'),
    name: 'root',
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('./views/transfer/index.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: '/cinema',
        name: 'cinema',
        component: () => import('./views/cinema/index.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: '/cinema-search',
        name: 'cinemaSearch',
        component: () => import('./views/cinema/Search.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: '/scrape-settings',
        name: 'scrapeSettings',
        component: () => import('./views/scrape-settings/index.vue'),
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('./views/new-login/index.vue'),
      },
      {
        path: '/upload',
        name: 'upload',
        component: () => import('./views/upload/index.vue'),
      },
      {
        path: '/files',
        name: 'files',
        component: () => import('./components/PanList.vue'),
      },
      {
        path: '/hezi-files',
        name: 'heziFiles',
        component: () => import('./views/hezi-files/index.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: '/me',
        name: 'me',
        component: () => import('./views/me/index.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: '/close',
        name: 'close',
        component: Close,
      },
      {
        path: '/signout',
        name: 'signout',
        component: Signout,
      },
      // {
      //   path: '/plugin',
      //   name: 'plugin',
      //   component: () => import('./views/plugin/index.vue'),
      // },
      {
        path: '/plugin-iframe',
        name: 'pluginIframe',
        component: () => import('./views/plugin/pluginIframe.vue'),
      },
      {
        path: '/more-info',
        name: 'moreInfo',
        component: () => import('./views/info/index.vue'),
      },
      {
        path: '/help',
        name: 'help',
        component: () => import('./views/info/help.vue'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('./views/info/about.vue'),
      },
      {
        path: '/device-info',
        name: 'deviceInfo',
        component: () => import('./views/info/device.vue'),
      },
      {
        path: '/device-bind',
        name: 'deviceBind',
        component: () => import('./views/device-bind/index.vue'),
      },
      {
        path: '/services',
        name: 'services',
        component: () => import('./views/services/index.vue'),
      },
      {
        path: '/services/detail',
        name: 'services-detail',
        component: () => import('./views/services/detail.vue'),
      },
      {
        path: '/disks',
        name: 'disks',
        component: () => import('./views/disks/index.vue'),
      },
      {
        path: '/disks/restore',
        name: 'disksRestore',
        component: () => import('./views/disks/Restore.vue'),
      },
      {
        path: '/disks/restore/result',
        name: 'disksRestoreResult',
        component: () => import('./views/disks/RestoreResult.vue'),
      },
      {
        path: '/disks/add/netdrives',
        name: 'disksAddExternal',
        component: () => import('./views/disks/AddNetDrives.vue'),
      },
      {
        path: '/settings/transmission',
        name: 'transmissionSettings',
        component: () => import('./views/settings/transmission.vue'),
      },
      {
        path: '/settings/service',
        name: 'serviceSettings',
        component: () => import('./views/settings/service.vue'),
      },
      {
        path: '/settings/account',
        name: 'accountSettings',
        component: () => import('./views/settings/account/index.vue'),
      },
      {
        path: '/settings/account/update',
        name: 'accountSettingsUpdate',
        component: () => import('./views/settings/account/update.vue'),
      },
      {
        path: '/cloud',
        name: 'cloud',
        component: () => import('./views/cloud/index.vue'),
      },
      {
        path: '/cloud/:provider',
        name: 'cloudFileViewer',
        component: () => import('./views/cloud/files.vue'),
      },
      {
        path: '/share',
        name: 'shareFileViewer',
        component: () => import('./views/share/index.vue'),
      },
      {
        path: '/album',
        name: 'album',
        component: () => import('./views/album/index.vue'),
      },
      {
        path: '/album/:path',
        name: 'albumPath',
        component: () => import('./views/album/path.vue'),
      },
    ],
  },
]

const VUE_APP_TAG = process.env.VUE_APP_TAG  || ''
console.log('router VUE_APP_TAG', VUE_APP_TAG)
const folder = VUE_APP_TAG.includes('bucket') && VUE_APP_TAG.indexOf('master') < 0 ? `${VUE_APP_TAG.substring(7)}/` : ''

export const router = createRouter({
  history: createWebHistory(`${publicPath}/${folder}`),
  routes,
})

// 每次切换路由，记录当前state。
// 用于实现，在某些特定路由下点击返回键，直接关闭页面。
// 但在页面内弹窗的场景下，需要按返回键关闭弹窗，这时不好改变路由。
// 只能通过修改一下curState去避免页面关闭逻辑触发。
export let curState = router.currentRoute.value.path
let curStateBackup = ''
let isDisabled = false

export const disableCloseOnBack = () => {
  isDisabled = true
  curStateBackup = curState
  curState = 'DISABLED'
}
export const enableCloseOnBack = () => {
  isDisabled = false
  curState = curStateBackup
  curStateBackup = ''
}
router.beforeEach(() => {
  if (!isDisabled) {
    curState = router.currentRoute.value.path
  }
})

export default router
